export const dict = {
  fr: {
    nav: {
      about: "L'agence",
      services: "Services",
      hadjj: "Hadjj & Umrah",
      destinations: "Destinations",
      testimonials: "Témoignages",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      eyebrow: "Agence de voyage — Mataró, Barcelona",
      title_lines: ["Voyagez", "à travers le", "monde entier."],
      lede: "Travel To Time conçoit des voyages sur-mesure — vols, hôtels, transferts, croisières et assistance humaine, avant, pendant et après votre départ.",
      book_now: "Réserver maintenant",
      quote: "Devis gratuit",
      form_title: "Parlons de votre prochain voyage",
      form_subtitle: "Une réponse personnalisée sous 24h.",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone / WhatsApp",
      destination: "Destination rêvée",
      message: "Racontez-nous votre projet…",
      submit: "Envoyer la demande",
      submitting: "Envoi…",
      success: "Merci — nous vous rappelons sous 24h.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    trust: {
      items: [
        "Certification agence IATA",
        "15 ans d'expérience",
        "Assistance 24/7 en 3 langues",
        "Paiement sécurisé",
        "Partenaire hôtels premium",
        "Assurance voyage incluse",
        "Sur-mesure pour groupes & familles",
        "Note 4.9 / 5",
      ],
    },
    services: {
      eyebrow: "Chapitres — 01 › 05",
      chapter: "Chapitre",
      book_cta: "Réserver",
      title: "Un service complet, orchestré comme une œuvre.",
      subtitle: "Nous prenons en charge chaque détail — de la première recherche au retour à la maison.",
      list: [
        {
          num: "01",
          title: "Vols & Transferts",
          desc: "Billets d'avion internationaux au meilleur tarif. Transferts aéroport-hôtel privés, chauffeur inclus.",
          tag: "Aériens",
        },
        {
          num: "02",
          title: "Autobus & Trains",
          desc: "Transport terrestre pour groupes ou voyageurs individuels. Solutions confort, express ou économique.",
          tag: "Terrestre",
        },
        {
          num: "03",
          title: "Hôtels & Appartements",
          desc: "Hébergements sélectionnés, du boutique-hôtel à la villa privée, selon vos besoins et budget.",
          tag: "Hébergement",
        },
        {
          num: "04",
          title: "Location & Assurances",
          desc: "Location de véhicules à l'international et assurances voyage complètes pour partir l'esprit tranquille.",
          tag: "Mobilité",
        },
        {
          num: "05",
          title: "Conseil & Accompagnement",
          desc: "Un conseiller dédié pour chaque voyageur. Organisation complète, en français, espagnol ou anglais.",
          tag: "Concierge",
        },
      ],
    },
    why: {
      eyebrow: "Pourquoi Travel To Time",
      title: "Votre satisfaction. Notre priorité.",
      items: [
        { t: "Expertise internationale", d: "Une équipe qui connaît réellement les destinations que nous vendons." },
        { t: "Service personnalisé", d: "Un conseiller unique, joignable directement par WhatsApp." },
        { t: "Prix compétitifs", d: "Nos partenariats hôteliers et aériens vous garantissent le meilleur tarif." },
        { t: "Assistance 24/7", d: "Avant, pendant et après le voyage — nous restons à vos côtés." },
        { t: "Groupes & familles", d: "Solutions adaptées aux voyages professionnels, en famille ou entre amis." },
      ],
    },
    destinations: {
      eyebrow: "Destinations phares",
      title: "Huit horizons. Huit manières de partir.",
      list: [
        { code: "ES", flag: "🇪🇸", name: "Espagne", tag: "Andalousie, Barcelone" },
        { code: "MA", flag: "🇲🇦", name: "Maroc", tag: "Marrakech, désert" },
        { code: "GN", flag: "🇬🇳", name: "Guinée", tag: "Conakry, Fouta" },
        { code: "FR", flag: "🇫🇷", name: "France", tag: "Paris, Provence" },
        { code: "IT", flag: "🇮🇹", name: "Italie", tag: "Rome, Amalfi" },
        { code: "TR", flag: "🇹🇷", name: "Turquie", tag: "Istanbul, Cappadoce" },
        { code: "AE", flag: "🇦🇪", name: "Émirats", tag: "Dubaï, Abu Dhabi" },
        { code: "SA", flag: "🇸🇦", name: "La Mecque", tag: "Hadjj & Umrah · Kaaba" },
      ],
    },
    booking: {
      eyebrow: "Réservation express",
      title: "Obtenez votre devis en 60 secondes.",
      subtitle: "Renseignez vos préférences — un conseiller reprend contact.",
      destination: "Destination",
      departure: "Date de départ",
      return: "Date de retour",
      travelers: "Voyageurs",
      service: "Type de service",
      services_opts: {
        flight: "Vol seul",
        hotel: "Hôtel seul",
        transport: "Transport",
        package: "Pack complet",
      },
      name: "Votre nom",
      email: "Email",
      phone: "WhatsApp",
      submit: "Obtenir mon devis",
      submitting: "Envoi…",
      success: "Devis envoyé — nous vous répondons rapidement.",
    },
    deposit: {
      badge: "Étape 2 · Facultatif",
      title: "Sécurisez votre réservation.",
      subtitle: "Un acompte 100% remboursable garantit votre place et débloque des tarifs prioritaires. Aucun engagement définitif à cette étape.",
      pkg_labels: { small: "Voyage standard", medium: "Voyage premium", large: "Circuit / groupe" },
      guarantees: [
        "100% remboursable jusqu'à 30 jours avant le départ",
        "Déduit du prix total de votre voyage",
        "Paiement sécurisé Stripe · SSL",
      ],
      cta: "Payer l'acompte",
      loading: "Redirection sécurisée…",
      skip: "Ignorer — je préfère être contacté d'abord",
      error: "Le paiement n'a pas pu être initialisé. Réessayez.",
    },
    hadjj: {
      eyebrow: "Nouveau service · Spiritualité",
      badge: "Nouveau",
      guide_label: "Guide",
      guide_value: "Très expérimenté",
      rate_label: "Tarifs",
      rate_value: "Accessibles",
      title_lines: ["Hadjj &", "Umrah", "en toute sérénité."],
      body: "Travel To Time a intégré à ses services l'organisation complète des pèlerinages Hadjj & Umrah, encadrés par un guide très expérimenté. Voyager n'est pas cher — l'agence propose des tarifs accessibles adaptés à vos possibilités, pour que chacun puisse accomplir ce voyage sacré.",
      features: [
        "Accompagnement par un guide expérimenté",
        "Formalités visa & logistique intégrales",
        "Hébergement à proximité des lieux saints",
        "Tarifs accessibles, paiement facilité",
        "Groupes francophones, hispanophones",
        "Assistance avant, pendant et après",
      ],
      cta_primary: "Demander un devis",
      cta_secondary: "WhatsApp direct",
    },
    engine: {
      eyebrow: "Moteur de réservation · 24 / 7",
      title_lines: ["Réservez", "en ligne,", "en direct."],
      body: "Comparez et réservez vous-même vols, hôtels, voitures et croisières sur notre plateforme officielle — tarifs en temps réel, plus de 40 devises et 20 langues, paiement sécurisé.",
      modules: [
        { key: "flights", label: "Vols" },
        { key: "hotels", label: "Hôtels" },
        { key: "apartments", label: "Appartements" },
        { key: "flight_and_hotel", label: "Vol + Hôtel" },
      ],
      currencies_label: "Devises acceptées",
      languages_label: "Langues disponibles",
      trending_label: "Destinations tendance",
      cta_primary: "Ouvrir le moteur",
      cta_secondary: "Parler à un conseiller",
      note: "Redirection sécurisée vers traveltotime.com",
    },
    testimonials: {
      eyebrow: "Témoignages",
      title: "Ce que disent nos voyageurs.",
      list: [
        { q: "Une expérience impeccable du premier appel jusqu'au retour.", n: "Aïcha B.", c: "Marrakech, 2024" },
        { q: "Mamadou nous a organisé un mariage à Istanbul — inoubliable.", n: "Sofia & Marc", c: "Istanbul, 2024" },
        { q: "Réactivité, sérieux, prix imbattables. Nous ne changerons plus.", n: "Jean-Pierre D.", c: "Dubaï, 2025" },
        { q: "Un voyage en famille sans le moindre stress. Merci Travel To Time.", n: "Famille Diallo", c: "Conakry, 2025" },
      ],
    },
    cta: {
      overline: "Prêt à partir ?",
      title_lines: ["Votre prochaine", "destination", "commence ici."],
      subtitle: "Appelez-nous, écrivez-nous ou passez à l'agence — nous parlons français, espagnol et anglais.",
      call: "Appeler",
      whatsapp: "WhatsApp",
      email: "Email",
      slogan: "En Travel To Time, votre satisfaction est notre priorité.",
    },
    footer: {
      tagline: "Votre partenaire pour voyager dans le monde entier.",
      contact: "Contact",
      hours: "Horaires",
      hours_val: "Lun–Sam · 10:00 — 19:00",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      terms: "Conditions générales",
      copy: "© 2026 Travel To Time — Tous droits réservés.",
      social: "Réseaux",
      google_cta: "Voir sur Google",
      address_label: "Adresse",
      contact_label: "Contact",
    },
  },

  es: {
    nav: {
      about: "La agencia",
      services: "Servicios",
      hadjj: "Hadjj y Umrah",
      destinations: "Destinos",
      testimonials: "Testimonios",
      contact: "Contacto",
      book: "Reservar",
    },
    hero: {
      eyebrow: "Agencia de viajes — Mataró, Barcelona",
      title_lines: ["Viaje por", "el mundo", "entero."],
      lede: "Travel To Time diseña viajes a medida — vuelos, hoteles, traslados, cruceros y asistencia humana antes, durante y después de su viaje.",
      book_now: "Reservar ahora",
      quote: "Presupuesto gratis",
      form_title: "Hablemos de su próximo viaje",
      form_subtitle: "Respuesta personalizada en 24h.",
      name: "Nombre completo",
      email: "Email",
      phone: "Teléfono / WhatsApp",
      destination: "Destino soñado",
      message: "Cuéntenos su proyecto…",
      submit: "Enviar solicitud",
      submitting: "Enviando…",
      success: "Gracias — le llamamos en 24h.",
      error: "Ha ocurrido un error. Inténtelo de nuevo.",
    },
    trust: {
      items: [
        "Certificación agencia IATA",
        "15 años de experiencia",
        "Asistencia 24/7 en 3 idiomas",
        "Pago seguro",
        "Socio de hoteles premium",
        "Seguro de viaje incluido",
        "A medida para grupos y familias",
        "Valoración 4,9 / 5",
      ],
    },
    services: {
      eyebrow: "Capítulos — 01 › 05",
      chapter: "Capítulo",
      book_cta: "Reservar",
      title: "Un servicio completo, orquestado como una obra.",
      subtitle: "Nos ocupamos de cada detalle — desde la primera búsqueda hasta la vuelta a casa.",
      list: [
        { num: "01", title: "Vuelos y Traslados", desc: "Billetes internacionales al mejor precio. Traslados aeropuerto-hotel privados, chófer incluido.", tag: "Aéreos" },
        { num: "02", title: "Autobuses y Trenes", desc: "Transporte terrestre para grupos o viajeros individuales. Confort, express o económico.", tag: "Terrestre" },
        { num: "03", title: "Hoteles y Apartamentos", desc: "Alojamientos seleccionados, de hotel boutique a villa privada, según sus necesidades y presupuesto.", tag: "Alojamiento" },
        { num: "04", title: "Alquiler y Seguros", desc: "Alquiler de vehículos internacional y seguros de viaje completos para partir tranquilo.", tag: "Movilidad" },
        { num: "05", title: "Asesoría y Acompañamiento", desc: "Un asesor dedicado para cada viajero. Organización completa en francés, español o inglés.", tag: "Concierge" },
      ],
    },
    why: {
      eyebrow: "Por qué Travel To Time",
      title: "Su satisfacción. Nuestra prioridad.",
      items: [
        { t: "Experiencia internacional", d: "Un equipo que conoce realmente los destinos que ofrece." },
        { t: "Servicio personalizado", d: "Un asesor único, accesible directamente por WhatsApp." },
        { t: "Precios competitivos", d: "Nuestras alianzas hoteleras y aéreas garantizan el mejor precio." },
        { t: "Asistencia 24/7", d: "Antes, durante y después del viaje — permanecemos a su lado." },
        { t: "Grupos y familias", d: "Soluciones adaptadas a viajes profesionales, familiares o entre amigos." },
      ],
    },
    destinations: {
      eyebrow: "Destinos estrella",
      title: "Ocho horizontes. Ocho formas de partir.",
      list: [
        { code: "ES", flag: "🇪🇸", name: "España", tag: "Andalucía, Barcelona" },
        { code: "MA", flag: "🇲🇦", name: "Marruecos", tag: "Marrakech, desierto" },
        { code: "GN", flag: "🇬🇳", name: "Guinea", tag: "Conakry, Fouta" },
        { code: "FR", flag: "🇫🇷", name: "Francia", tag: "París, Provenza" },
        { code: "IT", flag: "🇮🇹", name: "Italia", tag: "Roma, Amalfi" },
        { code: "TR", flag: "🇹🇷", name: "Turquía", tag: "Estambul, Capadocia" },
        { code: "AE", flag: "🇦🇪", name: "Emiratos", tag: "Dubái, Abu Dhabi" },
        { code: "SA", flag: "🇸🇦", name: "La Meca", tag: "Hadjj y Umrah · Kaaba" },
      ],
    },
    booking: {
      eyebrow: "Reserva rápida",
      title: "Su presupuesto en 60 segundos.",
      subtitle: "Indíquenos sus preferencias — un asesor le contacta.",
      destination: "Destino",
      departure: "Fecha de salida",
      return: "Fecha de regreso",
      travelers: "Viajeros",
      service: "Tipo de servicio",
      services_opts: { flight: "Solo vuelo", hotel: "Solo hotel", transport: "Transporte", package: "Paquete completo" },
      name: "Su nombre",
      email: "Email",
      phone: "WhatsApp",
      submit: "Obtener presupuesto",
      submitting: "Enviando…",
      success: "Presupuesto enviado — le respondemos pronto.",
    },
    deposit: {
      badge: "Paso 2 · Opcional",
      title: "Asegure su reserva.",
      subtitle: "Un depósito 100% reembolsable garantiza su plaza y desbloquea tarifas prioritarias. Sin compromiso definitivo en esta etapa.",
      pkg_labels: { small: "Viaje estándar", medium: "Viaje premium", large: "Circuito / grupo" },
      guarantees: [
        "100% reembolsable hasta 30 días antes de la salida",
        "Se descuenta del precio total del viaje",
        "Pago seguro Stripe · SSL",
      ],
      cta: "Pagar el depósito",
      loading: "Redirección segura…",
      skip: "Omitir — prefiero ser contactado primero",
      error: "El pago no se pudo iniciar. Inténtelo de nuevo.",
    },
    hadjj: {
      eyebrow: "Nuevo servicio · Espiritualidad",
      badge: "Nuevo",
      guide_label: "Guía",
      guide_value: "Muy experimentado",
      rate_label: "Tarifas",
      rate_value: "Accesibles",
      title_lines: ["Hadjj y", "Umrah", "con toda serenidad."],
      body: "La agencia Travel To Time les informa que ha incorporado en sus servicios las actividades de HADJJ & UMRAH bajo la orientación de un guía muy experimentado. Viajar no es caro — esta agencia les ofrece TARIFAS ACCESIBLES adaptadas a sus posibilidades, para que cada uno pueda realizar este viaje sagrado.",
      features: [
        "Acompañamiento por un guía experimentado",
        "Gestión completa de visado y logística",
        "Alojamiento cercano a los lugares santos",
        "Tarifas accesibles, pago facilitado",
        "Grupos en francés y español",
        "Asistencia antes, durante y después",
      ],
      cta_primary: "Solicitar presupuesto",
      cta_secondary: "WhatsApp directo",
    },
    engine: {
      eyebrow: "Motor de reservas · 24 / 7",
      title_lines: ["Reserve", "en línea,", "en directo."],
      body: "Compare y reserve directamente vuelos, hoteles, coches y cruceros en nuestra plataforma oficial — tarifas en tiempo real, más de 40 divisas y 20 idiomas, pago seguro.",
      modules: [
        { key: "flights", label: "Vuelos" },
        { key: "hotels", label: "Hoteles" },
        { key: "apartments", label: "Apartamentos" },
        { key: "flight_and_hotel", label: "Vuelo + Hotel" },
      ],
      currencies_label: "Divisas aceptadas",
      languages_label: "Idiomas disponibles",
      trending_label: "Destinos populares",
      cta_primary: "Abrir el motor",
      cta_secondary: "Hablar con un asesor",
      note: "Redirección segura a traveltotime.com",
    },
    testimonials: {
      eyebrow: "Testimonios",
      title: "Lo que dicen nuestros viajeros.",
      list: [
        { q: "Una experiencia impecable desde la primera llamada hasta la vuelta.", n: "Aïcha B.", c: "Marrakech, 2024" },
        { q: "Mamadou nos organizó una boda en Estambul — inolvidable.", n: "Sofía & Marc", c: "Estambul, 2024" },
        { q: "Rapidez, seriedad, precios inmejorables. No cambiaremos más.", n: "Jean-Pierre D.", c: "Dubái, 2025" },
        { q: "Un viaje en familia sin el menor estrés. Gracias Travel To Time.", n: "Familia Diallo", c: "Conakry, 2025" },
      ],
    },
    cta: {
      overline: "¿Listo para partir?",
      title_lines: ["Su próximo", "destino", "empieza aquí."],
      subtitle: "Llámenos, escríbanos o visítenos — hablamos francés, español e inglés.",
      call: "Llamar",
      whatsapp: "WhatsApp",
      email: "Email",
      slogan: "En Travel To Time, su satisfacción es nuestra prioridad.",
    },
    footer: {
      tagline: "Su partenaire para viajar por todo el mundo.",
      contact: "Contacto",
      hours: "Horario",
      hours_val: "Lun–Sáb · 10:00 — 19:00",
      legal: "Aviso legal",
      privacy: "Política de privacidad",
      terms: "Términos y condiciones",
      copy: "© 2026 Travel To Time — Todos los derechos reservados.",
      social: "Redes",
      google_cta: "Ver en Google",
      address_label: "Dirección",
      contact_label: "Contacto",
    },
  },

  en: {
    nav: {
      about: "Agency",
      services: "Services",
      hadjj: "Hadjj & Umrah",
      destinations: "Destinations",
      testimonials: "Reviews",
      contact: "Contact",
      book: "Book",
    },
    hero: {
      eyebrow: "Travel agency — Mataró, Barcelona",
      title_lines: ["Travel", "the whole", "wide world."],
      lede: "Travel To Time crafts tailor-made journeys — flights, hotels, transfers, cruises and a real human by your side before, during and after you leave.",
      book_now: "Book now",
      quote: "Free quote",
      form_title: "Let's talk about your next trip",
      form_subtitle: "Personalised reply within 24 hours.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      destination: "Dream destination",
      message: "Tell us about your project…",
      submit: "Send request",
      submitting: "Sending…",
      success: "Thank you — we'll call you within 24h.",
      error: "Something went wrong. Please try again.",
    },
    trust: {
      items: [
        "IATA-certified agency",
        "15 years of experience",
        "24/7 support in 3 languages",
        "Secure payment",
        "Premium hotel partner",
        "Travel insurance included",
        "Bespoke for families & groups",
        "Rated 4.9 / 5",
      ],
    },
    services: {
      eyebrow: "Chapters — 01 › 05",
      chapter: "Chapter",
      book_cta: "Book",
      title: "One complete service, orchestrated like a piece of work.",
      subtitle: "We handle every detail — from the first search to your return home.",
      list: [
        { num: "01", title: "Flights & Transfers", desc: "International flight tickets at the best rate. Private airport-hotel transfers, driver included.", tag: "Air" },
        { num: "02", title: "Coaches & Trains", desc: "Ground transportation for groups or individuals. Comfort, express or economy options.", tag: "Ground" },
        { num: "03", title: "Hotels & Apartments", desc: "Hand-picked stays, from boutique hotels to private villas, tailored to your needs and budget.", tag: "Stays" },
        { num: "04", title: "Rentals & Insurance", desc: "International car rentals and full travel insurance so you leave with peace of mind.", tag: "Mobility" },
        { num: "05", title: "Advice & Support", desc: "A dedicated advisor for every traveller. Full planning in French, Spanish or English.", tag: "Concierge" },
      ],
    },
    why: {
      eyebrow: "Why Travel To Time",
      title: "Your satisfaction. Our priority.",
      items: [
        { t: "International expertise", d: "A team who genuinely knows the destinations we sell." },
        { t: "Personalised service", d: "One dedicated advisor, reachable directly on WhatsApp." },
        { t: "Competitive pricing", d: "Our hotel and airline partnerships guarantee the best rate." },
        { t: "24/7 assistance", d: "Before, during and after — we stay by your side." },
        { t: "Groups & families", d: "Bespoke solutions for professional, family or friend trips." },
      ],
    },
    destinations: {
      eyebrow: "Featured destinations",
      title: "Eight horizons. Eight ways to depart.",
      list: [
        { code: "ES", flag: "🇪🇸", name: "Spain", tag: "Andalusia, Barcelona" },
        { code: "MA", flag: "🇲🇦", name: "Morocco", tag: "Marrakech, desert" },
        { code: "GN", flag: "🇬🇳", name: "Guinea", tag: "Conakry, Fouta" },
        { code: "FR", flag: "🇫🇷", name: "France", tag: "Paris, Provence" },
        { code: "IT", flag: "🇮🇹", name: "Italy", tag: "Rome, Amalfi" },
        { code: "TR", flag: "🇹🇷", name: "Türkiye", tag: "Istanbul, Cappadocia" },
        { code: "AE", flag: "🇦🇪", name: "UAE", tag: "Dubai, Abu Dhabi" },
        { code: "SA", flag: "🇸🇦", name: "Mecca", tag: "Hadjj & Umrah · Kaaba" },
      ],
    },
    booking: {
      eyebrow: "Express booking",
      title: "Get your quote in 60 seconds.",
      subtitle: "Tell us your preferences — an advisor gets back to you.",
      destination: "Destination",
      departure: "Departure date",
      return: "Return date",
      travelers: "Travellers",
      service: "Service type",
      services_opts: { flight: "Flight only", hotel: "Hotel only", transport: "Transport", package: "Full package" },
      name: "Your name",
      email: "Email",
      phone: "WhatsApp",
      submit: "Get my quote",
      submitting: "Sending…",
      success: "Quote sent — we'll be in touch shortly.",
    },
    deposit: {
      badge: "Step 2 · Optional",
      title: "Secure your booking.",
      subtitle: "A 100% refundable deposit locks in your spot and unlocks priority rates. No final commitment at this stage.",
      pkg_labels: { small: "Standard trip", medium: "Premium trip", large: "Tour / group" },
      guarantees: [
        "100% refundable up to 30 days before departure",
        "Deducted from your final trip price",
        "Secure Stripe payment · SSL",
      ],
      cta: "Pay the deposit",
      loading: "Secure redirect…",
      skip: "Skip — I'd rather be contacted first",
      error: "Payment could not be initialised. Please try again.",
    },
    hadjj: {
      eyebrow: "New service · Spirituality",
      badge: "New",
      guide_label: "Guide",
      guide_value: "Highly experienced",
      rate_label: "Rates",
      rate_value: "Accessible",
      title_lines: ["Hadjj &", "Umrah", "with true serenity."],
      body: "Travel To Time has added the full organisation of Hadjj & Umrah pilgrimages to its services, led by a highly experienced guide. Travel doesn't have to be expensive — the agency offers accessible rates adapted to your means, so anyone can undertake this sacred journey.",
      features: [
        "Guided by an experienced pilgrimage leader",
        "Full visa & logistics handled",
        "Accommodation near the holy sites",
        "Accessible rates, flexible payment",
        "French- and Spanish-speaking groups",
        "Support before, during and after",
      ],
      cta_primary: "Request a quote",
      cta_secondary: "Direct WhatsApp",
    },
    engine: {
      eyebrow: "Booking engine · 24 / 7",
      title_lines: ["Book online,", "in real", "time."],
      body: "Compare and book flights, hotels, cars and cruises yourself on our official platform — real-time fares, 40+ currencies and 20 languages, secure payment.",
      modules: [
        { key: "flights", label: "Flights" },
        { key: "hotels", label: "Hotels" },
        { key: "apartments", label: "Apartments" },
        { key: "flight_and_hotel", label: "Flight + Hotel" },
      ],
      currencies_label: "Accepted currencies",
      languages_label: "Available languages",
      trending_label: "Trending destinations",
      cta_primary: "Open the engine",
      cta_secondary: "Talk to an advisor",
      note: "Secure redirect to traveltotime.com",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "What our travellers say.",
      list: [
        { q: "A flawless experience from the first call to the return.", n: "Aïcha B.", c: "Marrakech, 2024" },
        { q: "Mamadou organised a wedding in Istanbul for us — unforgettable.", n: "Sofia & Marc", c: "Istanbul, 2024" },
        { q: "Responsive, serious, unbeatable prices. We won't be switching.", n: "Jean-Pierre D.", c: "Dubai, 2025" },
        { q: "A family trip without a single moment of stress. Thank you.", n: "Diallo family", c: "Conakry, 2025" },
      ],
    },
    cta: {
      overline: "Ready to leave?",
      title_lines: ["Your next", "destination", "starts here."],
      subtitle: "Call us, write to us or drop by — we speak French, Spanish and English.",
      call: "Call",
      whatsapp: "WhatsApp",
      email: "Email",
      slogan: "At Travel To Time, your satisfaction is our priority.",
    },
    footer: {
      tagline: "Your partner for travelling the whole wide world.",
      contact: "Contact",
      hours: "Hours",
      hours_val: "Mon–Sat · 10:00 — 19:00",
      legal: "Legal",
      privacy: "Privacy policy",
      terms: "Terms & conditions",
      copy: "© 2026 Travel To Time — All rights reserved.",
      social: "Social",
      google_cta: "See on Google",
      address_label: "Address",
      contact_label: "Contact",
    },
  },
};

export const AGENCY = {
  name: "Travel To Time",
  contact_person: "Mamadou Aliou",
  phone: "+34 680 856 937",
  phone_raw: "+34680856937",
  whatsapp: "34680856937",
  email: "info@traveltotime.com",
  website: "www.traveltimes.com",
  booking_url: "https://www.traveltotime.com",
  address: "Avenida Perú, 70",
  address2: "08304 Mataró, Barcelona, España",
};

export const TRENDING = [
  { name: "Paris", country: "France", img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Londres", country: "UK", img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Porto", country: "Portugal", img: "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Dublin", country: "Irlande", img: "https://images.unsplash.com/photo-1549918864-48ac978761a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Munich", country: "Allemagne", img: "https://images.unsplash.com/photo-1595867818082-083862f3d630?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Madrid", country: "Espagne", img: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const CURRENCIES = ["EUR", "USD", "GBP", "MAD", "SAR", "AED", "CHF", "JPY"];
export const LANGUAGES_SUPPORTED = ["FR", "ES", "EN", "DE", "IT", "PT", "AR", "CA", "NL"];
